// MobileMenu.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import KofiModal from './KofiModal';

const MobileMenu = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [kofiOpen, setKofiOpen] = useState(false);

    const openModal = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const handleSupportClick = () => {
        closeModal();
        // Small delay so the mobile menu closes first
        setTimeout(() => setKofiOpen(true), 150);
    };

    return (
        <>
            <span className="ml-auto">
                {/* menu-toggle */}
                <div className="menu-toggle mobile:mt-1" onClick={openModal}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
            </span>

            <Modal
                isOpen={modalOpen}
                onRequestClose={closeModal}
                contentLabel="Mobile Menu Modal"
                style={{
                    content: {
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        border: 'none',
                        background: '#d6d6d6', /* matches theme grey */
                        padding: '20',
                        height: '100%',
                        width: '100%',
                        textAlign: 'center',
                        zIndex: '50',
                    },
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: '49',
                    },
                }}
            >
                <div className="menu-links">
                    <div className="arrow-menu">
                        <Link onClick={closeModal}>⤎</Link>
                    </div>

                    <Link to="/" onClick={closeModal}>
                        Claims
                    </Link>

                    <Link to="/about" onClick={closeModal}>
                        About
                    </Link>

                    {/* Hidden until ready to launch publicly
                    <Link to="/organisations" onClick={closeModal}>
                        Organisations
                    </Link>

                    <Link to="/materials" onClick={closeModal}>
                        Materials
                    </Link>

                    <Link to="/incidents" onClick={closeModal}>
                        Incidents
                    </Link>

                    <span className="break"></span>

                    <Link to="/submit" onClick={closeModal}>
                        Submit
                    </Link>

                    <Link to="/contact" onClick={closeModal}>
                        Get in touch
                    </Link>
                    */}

                    <span className="break"></span>

                    <button
                        onClick={handleSupportClick}
                        className="mobile-menu-btn"
                        style={{
                            background: 'none',
                            border: 'none',
                            font: 'inherit',
                            color: 'inherit',
                            cursor: 'pointer',
                            padding: 0,
                            textAlign: 'center',
                            width: '100%',
                        }}
                    >
                        Support us
                    </button>

                    <Link to="/contact" onClick={closeModal}>
                        Contact
                    </Link>

                    <a href="https://www.instagram.com/hasbaratracker/" target="_blank" rel="noreferrer" onClick={closeModal}>
                        Instagram
                    </a>

                    <a href="https://x.com/hasbaratracker" target="_blank" rel="noreferrer" onClick={closeModal}>
                        X
                    </a>
                </div>
            </Modal>

            <KofiModal isOpen={kofiOpen} onClose={() => setKofiOpen(false)} />
        </>
    );
};

export default MobileMenu;
